import {AppActions} from '@ignitesales/neuro-application';
import {DialogueActions, DialogueActionsStorageKeys} from "./DialogueActions.mjs";
import {setColorsInDom} from "../utils/colorHelper.mjs";

const dialogueReducer = (state, action) => {
    switch (action.type) {
        case AppActions.APP_READY: {
            const localColorConfig = JSON.parse( window.localStorage.getItem(DialogueActionsStorageKeys.THEME_RUNNER_COLORS) ) || {};
            const localFdicConfig = JSON.parse( window.localStorage.getItem(DialogueActionsStorageKeys.THEME_RUNNER_FDIC) ) || false;

            const localEhlConfig = JSON.parse( window.localStorage.getItem(DialogueActionsStorageKeys.THEME_RUNNER_EHL) ) || false;
            //TODO: read from state object
            const colorsToSet = {
                primaryColor: localColorConfig?.primaryColor || action?.payload?.themeColors?.primaryColor,
                secondaryColor: localColorConfig?.secondaryColor || action?.payload?.themeColors?.secondaryColor
            }
            setColorsInDom( colorsToSet );
            return {
                ...state,
                themeColors: colorsToSet,
                isFdicMember: localFdicConfig?.isFdicMember || action?.payload?.isFdicMember,
                isEhlMember: localEhlConfig?.isEhlMember || action?.payload?.isEhlMember
            };
        }

        case DialogueActions.THEME_COLORS_UPDATED: {
            const updatedColors = {
                primaryColor: action.primaryColor,
                secondaryColor: action.secondaryColor
            };
            return {
                ...state,
                themeColors: updatedColors
            };
        }

        case DialogueActions.THEME_FDIC_UPDATED: {
            return {
              ...state,
              isFdicMember: action.isFdicMember
            };
        }

        case DialogueActions.THEME_EHL_UPDATED: {
          return {
            ...state,
            isEhlMember: action.isEhlMember
          };
        }

        case DialogueActions.THEME_HIDE_ACTIONS_UPDATED: {
            return {
              ...state,
              hideActions: action.hideActions
            };
        }

        case DialogueActions.THEME_CONFIGURATION_UPDATED: {
            const updatedColors = {
              primaryColor: action.primaryColor,
              secondaryColor: action.secondaryColor
            };
            return {
              ...state,
              themeColors: updatedColors,
              isFdicMember: action.isFdicMember,
              isEhlMember: action.isEhlMember,
              hideActions: action.hideActions
            };
        }

        default:
            return state;
    }
};

export default dialogueReducer;
